import { render, staticRenderFns } from "./HeartIcon.vue?vue&type=template&id=48af17d6&"
import script from "./HeartIcon.vue?vue&type=script&lang=ts&"
export * from "./HeartIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports